import { useState } from "react";
import { useLoad } from "@/lib/hooks";
import { PageHeader, Section, NativeSelect } from "@/components/common";
import { useBranches } from "./shared";

function flatten(nodes, depth = 0, out = []) {
  for (const n of nodes) {
    out.push({ ...n, depth });
    flatten(n.reports, depth + 1, out);
  }
  return out;
}

function OrgRow({ n }) {
  return (
    <li>
      <div className="my-1 inline-flex items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2" style={{ marginLeft: n.depth * 28 }} data-testid={`org-node-${n.id}`}>
        <span className="h-2 w-2 rounded-full bg-[#389F95]" />
        <div><div className="text-sm font-medium text-slate-900">{n.name}</div><div className="text-xs text-slate-500">{[n.role, n.department].filter(Boolean).join(" · ") || "—"}{n.status === "on_leave" ? " · on leave" : ""}</div></div>
      </div>
    </li>
  );
}

export default function OrgChart() {
  const branches = useBranches();
  const [branch, setBranch] = useState("");
  const [tree] = useLoad(`/hr/org-chart${branch ? `?branch_id=${branch}` : ""}`);
  return (
    <div className="space-y-6">
      <PageHeader title="Org chart" subtitle="Read-only reporting structure, built from each employee's 'Reports to'." />
      <Section title="Reporting structure" testId="org-chart" action={<NativeSelect testId="org-branch-select" className="w-56" value={branch} onChange={setBranch} placeholder="All branches" options={branches} />}>
        <ul className="overflow-x-auto p-5">{tree?.length === 0 && <li className="text-sm text-slate-400">No employees in this branch.</li>}{tree && flatten(tree).map((n) => <OrgRow key={n.id} n={n} />)}</ul>
      </Section>
    </div>
  );
}
